import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { InsurancePolicyDataService, PolicyProductIdEnum, PurchasedProductInterface } from 'outshared-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const OTHER_PRODUCT_ID_LIST: PolicyProductIdEnum[] = [
    PolicyProductIdEnum.Car,
    PolicyProductIdEnum.Moped,
    PolicyProductIdEnum.Home,
    PolicyProductIdEnum.LegalAssistance,
    PolicyProductIdEnum.Motorcycle,
    PolicyProductIdEnum.Pet,
    PolicyProductIdEnum.Travel,
    PolicyProductIdEnum.Caravan,
    PolicyProductIdEnum.Liability,
    PolicyProductIdEnum.Accidents,
    PolicyProductIdEnum.Bicycle,
];

@Component({
    selector: 'ins-terms-and-conditions-container',
    template: `
        <ins-terms-and-conditions
            [userProductIdList]="userProductIdList$ | async"
            [otherProductIdList]="otherProductIdList$ | async"
        ></ins-terms-and-conditions>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsAndConditionContainer implements OnInit {

    public userProductIdList$?: Observable<PolicyProductIdEnum[]>;
    public otherProductIdList$: Observable<PolicyProductIdEnum[]>;

    constructor(
        private insurancePolicyDataService: InsurancePolicyDataService,
    ) {}

    ngOnInit(): void {
        this.userProductIdList$ = this.getUserProductIdList$();
        this.otherProductIdList$ = this.getOtherProductIdList$();
    }

    private getUserProductIdList$(): Observable<PolicyProductIdEnum[]> {
        return this.insurancePolicyDataService.getPurchasedProducts$().pipe(
            map((purchasedProducts: PurchasedProductInterface[]): PolicyProductIdEnum[] => {
                const productIds = purchasedProducts.map((purchasedProduct: PurchasedProductInterface) => {
                    return purchasedProduct.productId;
                });

                // new Set to get rid of duplicates
                return [...new Set(productIds)];
            }),
        );
    }

    private getOtherProductIdList$(): Observable<PolicyProductIdEnum[]> {
        return this.userProductIdList$.pipe(
            map((userProductIdList: PolicyProductIdEnum[]): PolicyProductIdEnum[] => {
                return OTHER_PRODUCT_ID_LIST.filter(
                    (productId: PolicyProductIdEnum) => {
                        return !userProductIdList.includes(productId);
                    },
                );
            }),
        );
    }
}
